export default __webpack_public_path__ + "static/media/Bg1.c6c834f7.jpg";